import { SimplePermissionControl } from './middlewares/permission.js'
import CacheWrapper from './middlewares/cache_wrapper.js'
import { runBackgroundJobs } from './background_job.js'
import { requestLog } from './middlewares/request_log.js'
import Normalization from './middlewares/normalization.js'
import { Auth, isAuthError } from './middlewares/auth.js'
import { RateLimit } from './middlewares/rate_limit.js'
import utils from './utils/index.js'
import { forwardCall, forwardCallByName } from './forward_call.js'

export const wrappers = {
  Normalization,
  requestLog,
  SimplePermissionControl,
  CacheWrapper,
  Auth,
  RateLimit,
}

export const commonWorkers = {
  common_contract_worker:
    '47c156d1256bfecc89d078fdca15540ec3c1c2a805d66e7e2c1d965ef720bb6e',
  redis_worker:
    'f9947ee39241d29961b868961f8aed6ed1d7b6447b7fa5901f8dc4cf8684d257',
  tester_worker:
    'ffad90d514163d3db7f70dc732de4d70313b493ef81e258c338fa4b8c421ff6d',
  kv_worker:
    '256002237da57cf4ddff942506837ab863cb02b544028cd3f6229d436fc15e4a',
  blockchain_utils_worker:
    'd3a31088279579331bebd552ea11e482ba2e1b1209197ef6bd6797fa3303eedb',
  notification_worker:
    '6cd61141c653cc948612910f0e64b5d5de3fb5ecc7821d4cd9c12b1b17a26837',
  blockchain_monitor_worker:
    '2a9af401857ce0d90fb57703eaacfc994f5e74575572534607ce5c4793e1d717',
  blockchain_defi_worker:
    '7ae8bc313701097663ffb50cda0753ab867c2d0d2ade87d9b0bb6a1a35fc8cb2',
  user_data_worker:
    '242ac5e2bbb305ab8d41a097b2366a306aec46450dd72070d6a4c12d6d9f8538',
  user_auth_worker:
    'da24247510d812babb574fd91f4e87f75dc3bb7e65d1840094427774190c157b',
  myagent_worker:
    '5a67f1b192b85c868a3e233346cf316ae2665a0d09874eb69118c8742ac93aba',
  capybara: '10ac615f10adc87e65acaeb81bc09ecba271aa2a67619fa480d037af94c6c055',
}

export { runBackgroundJobs, utils, forwardCall, forwardCallByName, isAuthError }

/**
 * Extract user ID from request context
 * @param {Object} ctx - Request context (contains auth_info from Auth middleware)
 * @returns {string|null} User ID or null
 */
export const getUserId = (ctx) => {
  if (ctx.auth_info?.sub) return ctx.auth_info.sub
  if (ctx.request?.public_key) return ctx.request.public_key
  return null
}

// Client factory functions for unified initialization
export {
  createWorkerClient,
  createFrontendClient,
  generateEphemeralPrivateKey,
  CHANNEL_SERVICE_URL,
  CHANNEL_WEBSOCKET_URL,
  NAMESPACE_SERVICE_URL,
} from './client_factory.js'
